export { default } from './ConsentModalContent';
